import { Button, Label, Radio, Spinner, Textarea } from 'flowbite-react';
import React, { useState } from 'react';
import { useToast } from 'src/context/ToastProvider';
import { LeadActionInput } from 'types';

interface Props {
	companyId: string;
	isLoading?: boolean;
	onSubmit: (data: LeadActionInput) => void;
}

const AMQualifyDisQualifyLead = ({ onSubmit, isLoading, companyId }: Props) => {
	const toast = useToast();
	const [disQualificationReason, setDisQualificationReason] = useState<string>('');

	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				try {
					const shareData: LeadActionInput = {
						companyId,
						action: 'disqualified',
						remarks: disQualificationReason,
					};
					onSubmit(shareData);
				} catch (err) {
					console.log('err:', err);
					toast({
						title: `Something went wrong! ${err}`,
						type: 'error',
					});
				}
			}}
		>
			<div className="mb-4 block whiteBgSelect p-4 gap-4">
				<div className="mb-[4px]">
					<Label>{'Lead Status '}</Label>
					<span className="text-[red]">*</span>
				</div>

				<div className="flex items-center gap-2">
					<Radio
						className="text-[#7777E7] focus:ring-[#7777E7]"
						id={'notQualified'}
						name="notQualified"
						value={'Not Qualified'}
						checked
					/>
					<Label htmlFor={'Not Qualified'} className="text-sm font-[400] font-inter">
						Not Qualified
					</Label>
				</div>
			</div>

			<div className="block">
				<div className="mb-[8px] flex justify-between items-end">
					<div>
						<Label>{'Your comments '}</Label>
						<span className="text-red-500">*</span>
					</div>

					<span className="italic text-xs text-[#6B7280] ">{(disQualificationReason?.length || 0) + ' / ' + 640}</span>
				</div>
				<Textarea
					name="message"
					maxLength={640}
					placeholder="Write text here ..."
					onChange={e => {
						setDisQualificationReason(e.target.value);
					}}
					className="border bg-white dark:text-white dark:border-[#4B5563] min-h-[100px] dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
				/>
			</div>

			<Button
				color="purplePlaced"
				type="submit"
				className="mt-[20px] mb-[20px] w-full bg-[#7777E7]"
				disabled={!disQualificationReason || isLoading}
			>
				{isLoading ? <Spinner /> : 'Confirm'}
			</Button>
		</form>
	);
};

export default AMQualifyDisQualifyLead;
